import { Builder } from '@builder.io/react';

// Heros
import 'react-scale/components/sections/hero/hero-default.builder';
import 'react-scale/components/sections/hero/hero-default-with-video.builder';
import 'react-scale/components/sections/hero/hero-default-with-slider.builder';
import 'react-scale/components/sections/hero/hero-default-with-image.builder';
import 'react-scale/components/sections/hero/hero-default-left.builder';
import 'react-scale/components/sections/hero/hero-centered.builder';
import 'react-scale/components/sections/hero/hero-with-spline.builder';
import 'react-scale/components/sections/hero/hero-with-nlp.builder';
import 'react-scale/components/templates/example.builder';

// Sections
import 'react-scale/components/templates/slide-gallery/slide-gallery.builder';
import 'react-scale/components/templates/features/features-with-image.builder';
import 'react-scale/components/templates/features/features-with-icon.builder';
// import 'react-scale/components/templates/features/features-with-slider.builder';
import 'react-scale/components/templates/features/features.builder';
import 'react-scale/components/templates/features-roi/features-roi.builder';
import 'react-scale/components/templates/enterprise/enterprise.builder';
import 'react-scale/components/templates/quality-assurance/quality-assurance.builder';
import 'react-scale/components/templates/logo-cloud/logo-cloud.builder';
import 'react-scale/components/templates/faq/faq.builder';
import 'react-scale/components/templates/quotes/quotes.builder';
import 'react-scale/components/templates/image/image.builder';
import 'react-scale/components/templates/features-side-by-side/features-side-by-side.builder';
import 'react-scale/components/templates/features-side-by-side-image/features-side-by-side-image.builder';
import 'react-scale/components/templates/features-vertical/features-vertical.builder';
import 'react-scale/components/templates/data-inputs/data-inputs.builder';
import 'react-scale/components/templates/gallery/gallery.builder';
import 'react-scale/components/templates/video-gallery/video-gallery.builder';
import 'react-scale/components/templates/pricing-llama/pricing-llama.builder';

// UI
import 'react-scale/components/sections/quotes/quotes.builder';
import 'react-scale/components/elements/image/image.builder';
import 'react-scale/components/sections/enterprise-features/enterprise-features.builder';
import 'react-scale/components/sections/text-block/text-block.builder';
import 'react-scale/components/sections/features-side-by-side/features-side-by-side.builder';
import 'react-scale/components/sections/features-side-by-side-image/features-side-by-side-image.builder';
import 'react-scale/components/sections/features-vertical/features-vertical.builder';
import 'react-scale/components/sections/data-inputs/data-inputs.builder';
import 'react-scale/components/sections/gallery/gallery.builder';
import 'react-scale/components/elements/text-spinner/text-spinner.builder';
import 'react-scale/components/elements/slide-gallery/slide-gallery.buillder';
import 'react-scale/components/sections/announcement-banner/announcement-banner.builder';
import 'react-scale/components/sections/events-banner/events-banner.builder';
import 'react-scale/components/elements/video/video.builder';
import 'react-scale/components/sections/comparison-table/comparison-table.builder';
import 'react-scale/components/pages/events/events.builder';
import 'react-scale/components/pages/homepage/dashed-line/dashed-line.builder';
import 'react-scale/components/pages/events/details/details.builder';
import 'react-scale/components/sections/pricing-llama/pricing.builder';

// delete
import 'react-scale/components/pages/smart-port/smart-port.builder';

// SUMMIT
import 'react-scale/components/pages/summit/access/access.builder';
import 'react-scale/components/pages/summit/header/header.builder';
import 'react-scale/components/pages/summit/hero/hero.builder';
import 'react-scale/components/pages/summit/counter/counter.builder';
import 'react-scale/components/pages/summit/slider/slider.builder';
import 'react-scale/components/pages/summit/schedule/schedule.builder';

const OVERRIDE_INSERT_MENU = true;

if (OVERRIDE_INSERT_MENU) {
  // (optionally) use this to hide all default built-in components and fully manage
  // the insert menu components and sections yourself
  Builder.register('editor.settings', { customInsertMenu: true });
}

Builder.register('insertMenu', {
  name: 'Hero',
  items: [
    // { item: 'HeroDefaultWithVideo', name: 'HeroWithVideo' },
    // { item: 'HeroDefaultWithImage', name: 'HeroWithImage' },
    // { name: 'HeroWithSpline' },
    { item: 'HeroDefaultWithSlider', name: 'HeroWithSlider' },
    { item: 'HeroDefaultLeft', name: 'HeroLeft' },
    { name: 'HeroCentered' },
    { name: 'HeroWithNLP' },
    { item: 'Centralized Hero Image', name: 'Hero with image' },
    { item: 'Centralized Hero Video', name: 'Hero with video' },
    { item: 'Centralized Hero Spline', name: 'Hero with spline' },
    { item: 'Centralized Hero Content', name: 'Hero with content' }
  ]
});

Builder.register('insertMenu', {
  name: 'CTA',
  items: [
    { item: 'CTASimpleCentered', name: 'SectionTryBanner' },
    { item: 'TextSpinner', name: 'TextSpinner' }
  ]
});

Builder.register('insertMenu', {
  name: 'QA',
  items: [{ name: 'SectionQualityAssurance' }]
});

Builder.register('insertMenu', {
  name: 'FAQ',
  items: [{ name: 'SectionFAQ' }]
});

Builder.register('insertMenu', {
  name: 'Images',
  items: [{ name: 'SectionImage' }]
});

Builder.register('insertMenu', {
  name: 'Videos',
  items: [{ name: 'SectionVideo' }]
});

Builder.register('insertMenu', {
  name: 'Quotes',
  items: [{ name: 'SectionQuotes' }]
});

Builder.register('insertMenu', {
  name: 'Summit',
  items: [
    { name: 'Summit Header' },
    { name: 'Summit Hero' },
    { name: 'Summit Counter' },
    { name: 'Summit Access Form' },
    { name: 'Summit Slider' },
    { name: 'Summit Schedule' }
  ]
});

Builder.register('insertMenu', {
  name: 'Features',
  items: [
    { name: 'SectionFeaturesWithImage' },
    { name: 'SectionFeaturesWithIcon' },
    // { name: 'SectionFeaturesWithSlider' },
    { name: 'SectionSlideGallery' },
    { name: 'SectionFeatures' },
    { name: 'SectionFeaturesROI' },
    { name: 'SectionEnterpriseFeatures' },
    { name: 'SectionFeaturesSideBySide' },
    { name: 'SectionFeaturesSideBySideImage' },
    { name: 'SectionFeaturesVertical' },
    { name: 'SectionDataInputs' },
    { name: 'SectionGallery' },
    { name: 'SectionVideoGallery' }
  ]
});

Builder.register('insertMenu', {
  name: 'Events',
  items: [
    { name: 'EventsList' },
    { name: 'EventsSlider' },
    { name: 'EventsHero' },
    { name: 'EventsDetails' }
  ]
});

Builder.register('insertMenu', {
  name: 'Content Boxes',
  items: [
    { name: 'DataBox' },
    { name: 'BoxRLHF' },
    { name: 'BoxDataCuration' },
    { name: 'BoxDataLabeling' },
    { name: 'SectionPricingLlama' }
  ]
});

Builder.register('insertMenu', {
  name: 'HIW',
  items: [{ name: 'SectionExample' }]
});

Builder.register('insertMenu', {
  name: 'Tables',
  items: [{ name: 'ComparisonTable' }]
});

Builder.register('insertMenu', {
  name: 'Logo Cloud',
  items: [{ name: 'SectionLogoCloud' }]
});

Builder.register('insertMenu', {
  name: 'Text',
  items: [{ name: 'TextBlock' }]
});

Builder.register('insertMenu', {
  name: 'Banners',
  items: [{ name: 'EventsBanner' }, { name: 'AnnouncementBanner' }]
});

Builder.register('insertMenu', {
  name: 'Custom Page Components',
  items: [{ name: 'SmartPortIllustration' }, { name: 'HorizontalLine' }]
});
